export const ASSET_ICONS: { [key: string]: string } = {
  sensor: 'fa-bug',
  agent: 'fa-binoculars',
  reach: 'fa-globe',
};
